/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description splash screen portal
 */

import React from 'react';
import ReactDOM from 'react-dom';

const dom = document.getElementById('status') as HTMLElement;

const SplashPortal: React.FC<Record<'status', string>> = ({ status }) => {
	const [innerHtmlEmptied, setInnerHtmlEmptied] = React.useState(false);
	React.useEffect(() => {
		if (!innerHtmlEmptied) {
			dom.innerHTML = '';
			setInnerHtmlEmptied(true);
		}
	}, [innerHtmlEmptied]);
	if (innerHtmlEmptied && dom) {
		return ReactDOM.createPortal(<>{status}</>, dom);
	}
	return null;
};

export default SplashPortal;
